<template>

    <file-pond
        maxFileSize="5MB"
        labelMaxFileSizeExceeded="Maximum file size is 5MB"
        name="photo"
        ref="pond"
        class="filepond"
        label-idle="<span class='filepond--label-action'>Aggiungi immagine</span> o rilascia i file per caricarli"
        allow-file-type-validation="true"
        allow-multiple=false
        :instantUpload="isExisting"
        accepted-file-types="image/png, image/jpeg, image/gif, image/jpg,"
        allowImagePreview=true
        allowImageCrop=false
        allowImageEdit=false
        allowImageResize=false
        allowImageTransform=false
        allowReplace=false
        allowImageExifOrientation=true
        checkValidity=true
        maxFiles=1
        imagePreviewHeight="95"
        imageCropAspectRatio="1:1"
        stylePanelLayout="compact"
        styleLoadIndicatorPosition="center bottom"
        styleProgressIndicatorPosition="right bottom"
        styleButtonRemoveItemPosition="left bottom"
        v-bind:allow-multiple="false"
        :server="server"
        v-bind:files="myFiles"
        v-on:init="handleFilePondInit"
    ></file-pond>
</template>

<script>
// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)
import EventBus from './EventBus'

export default {
  props: ['activityUuid', 'itemUuid'],
  data () {
    return {
      myFiles: []
    }
  },
  computed: {
    isExisting () {
      return this.itemUuid !== null
    },

    server () {
      return {
        process: {
          onload: (e) => {
            this.$refs.pond.removeFile(0)
            this.$emit('uploaded', JSON.parse(e))
            // this.$emit('uploaded', JSON.parse(e))
            this.$toasted.show('Image uploaded successfully', {
                    icon: 'info'
                  })
          },
          onerror: (e) => {
            this.$emit('uploaderror', JSON.parse(e))
          },
          url: '/activities/' + this.activityUuid + '/' + this.itemUuid + '/upload',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Accept': 'application/json',
            // 'Content-Type': 'multipart/form-data',
          }
        }
      }
    }
  },

  mounted () {
    let _this = this
    EventBus.$on('newContentAdded', function() {
      _this.$refs.pond.removeFile(0)
    })
  },

  methods: {
    handleFilePondInit () {
      let _this = this
      $('.filepond').on('FilePond:addfile', function(e) {
        if(!_this.isExisting){
          _this.$emit('added', e)
        }
        _this.$emit('resetuploaderror')
      }).on('FilePond:onprocessfile', function(e) {
        EventBus.$emit('newContentAdded')
      })
    }
  },
  components: {
    FilePond
  }
}
</script>

<style>
  .filepond--action-process-item {
      visibility:hidden;
  }
</style>
